import { Modal } from 'antd'
import { useSearchParams } from 'react-router-dom'
import { BRAND } from '@/constants/brand'

const HelpModal = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const open = searchParams.get('modal[help]') === '1'

  const close = () => {
    searchParams.delete('modal[help]')
    setSearchParams(searchParams)
  }

  return (
    <Modal title={`${BRAND.name}使用说明`} open={open} onCancel={close} footer={null} width={560}>
      <ol className="list-decimal space-y-3 pl-5 text-sm leading-relaxed">
        <li>
          <strong>新建论文</strong>：写清题目与研究问题，系统会给出 MBA 六章目录骨架。
        </li>
        <li>
          <strong>分章撰写</strong>：按章进入正文区，用内置动作生成或改写；生成前可补一句偏好。
        </li>
        <li>
          <strong>编审</strong>：对单章或全书做结构与表述检查，再自行定稿。
        </li>
        <li>
          <strong>账号与额度</strong>：注册即送体验额度；不够用再在账号菜单开通套餐。
        </li>
      </ol>
      <p className="thesis-callout mt-5 px-3 py-2 text-sm">
        {BRAND.name}是辅助写作工具，不是代写服务。引用、数据与结论请本人核实，并对论文负责。
      </p>
    </Modal>
  )
}

export default HelpModal
